import styled from "styled-components";

export const EntendiContainer = styled.div`
  margin: 32px 0;
`;

export const Text = styled.p`
  color: ${({ color }) => color || " #4D4D4D"};
  font-size: 16px;
  text-align: left;
  margin: 12px 0px;
  line-height: 24px;
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  cursor: pointer;

  input {
    margin-right: 8px;
    margin-left: 0;

    display: none;
    line-height: 24px;
  }
`;

export const CustomizedInput = styled.span`
  cursor: pointer;
  transition: 0.3s;
  margin-right: 8px;
  margin-top: -2px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
